<template>
  <transition name="md-fade-bottom">
    <div class="zk-table-filter" v-if="multiple" v-show="showPopper">
      <div class="zk-table-filter__content">
        <zk-checkbox-group class="zk-table-filter__checkbox-group" v-model="filteredValue">
          <zk-checkbox
            v-for="filter in filters"
            :label="filter.value">{{ filter.text }}</zk-checkbox>
        </zk-checkbox-group>
      </div>
      <div class="zk-table-filter__bottom">
        <button @click="handleConfirm"
          :class="{ 'is-disabled': filteredValue.length === 0 }"
          :disabled="filteredValue.length === 0">{{ t('el.table.confirmFilter') }}</button>
        <button @click="handleReset">{{ t('el.table.resetFilter') }}</button>
      </div>
    </div>
    <div class="zk-table-filter" v-else v-show="showPopper">
      <ul class="zk-table-filter__list">
        <li class="zk-table-filter__list-item"
            :class="{ 'is-active': !filterValue }"
            @click="handleSelect(null)">{{ t('el.table.clearFilter') }}</li>
        <li class="zk-table-filter__list-item"
            v-for="filter in filters"
            :label="filter.value"
            :class="{ 'is-active': isActive(filter) }"
            @click="handleSelect(filter.value)" >{{ filter.text }}</li>
      </ul>
    </div>
  </transition>
</template>

<script type="text/babel">
  import Popper from 'theme/utils/vue-popper'
  import Locale from 'theme/mixins/locale'
  import Clickoutside from 'theme/utils/clickoutside'
  import Dropdown from './dropdown'
  import ZkCheckbox from 'theme/packages/checkbox'
  import ZkCheckboxGroup from 'theme/packages/checkbox-group'

  export default {
    name: 'zk-table-filter-panel',

    mixins: [Popper, Locale],

    directives: {
      Clickoutside
    },

    components: {
      ZkCheckbox,
      ZkCheckboxGroup
    },

    props: {
      placement: {
        type: String,
        default: 'bottom-end'
      }
    },

    customRender(h) {
      return (<div class="zk-table-filter">
        <div class="zk-table-filter__content">
        </div>
        <div class="zk-table-filter__bottom">
          <button on-click={ this.handleConfirm }>{ this.t('el.table.confirmFilter') }</button>
          <button on-click={ this.handleReset }>{ this.t('el.table.resetFilter') }</button>
        </div>
      </div>)
    },

    methods: {
      isActive(filter) {
        return filter.value === this.filterValue
      },

      handleOutsideClick() {
        this.showPopper = false
      },

      handleConfirm() {
        this.confirmFilter(this.filteredValue)
        this.handleOutsideClick()
      },

      handleReset() {
        this.filteredValue = []
        this.confirmFilter(this.filteredValue)
        this.handleOutsideClick()
      },

      handleSelect(filterValue) {
        this.filterValue = filterValue

        if (filterValue) {
          this.confirmFilter(this.filteredValue)
        } else {
          this.confirmFilter([])
        }

        this.handleOutsideClick()
      },

      confirmFilter(filteredValue) {
        this.table.store.commit('filterChange', {
          column: this.column,
          values: filteredValue
        })
      }
    },

    data() {
      return {
        table: null,
        cell: null,
        column: null
      }
    },

    computed: {
      filters() {
        return this.column && this.column.filters
      },

      filterValue: {
        get() {
          return (this.column.filteredValue || [])[0]
        },
        set(value) {
          if (this.filteredValue) {
            if (value) {
              this.filteredValue.splice(0, 1, value)
            } else {
              this.filteredValue.splice(0, 1)
            }
          }
        }
      },

      filteredValue: {
        get() {
          if (this.column) {
            return this.column.filteredValue || []
          }
          return []
        },
        set(value) {
          if (this.column) {
            this.column.filteredValue = value
          }
        }
      },

      multiple() {
        if (this.column) {
          return this.column.filterMultiple
        }
        return true
      }
    },

    mounted() {
      this.popperElm = this.$el
      this.referenceElm = this.cell
      this.table.$refs.bodyWrapper.addEventListener('scroll', () => {
        this.updatePopper()
      })

      this.$watch('showPopper', (value) => {
        if (this.column) this.column.filterOpened = value
        if (value) {
          Dropdown.open(this)
        } else {
          Dropdown.close(this)
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// filter-panel.vue?76f28be0